// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ApiPagingRequestModel from '../../model/api-paging-request-model';
import ApiPagingRequestDTO from '../dto/api-paging-request-dto';
import dtoSchema from '../schemas/api-paging-request-schema';

export default abstract class ApiPagingRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ApiPagingRequestDTO>) {
    super();
    if (data) {
      this.currentPage = data.currentPage;
      this.pageSize = data.pageSize;
      this.includeCount = data.includeCount;
      this.noPaging = data.noPaging;
    }
  }
  /**
  * @type {int32}
  */
  currentPage?: number;
  /**
  * @type {int32}
  */
  pageSize?: number;
  /**
  */
  includeCount?: boolean;
  /**
  */
  noPaging?: boolean;

  static toModel(dto: DeepPartial<ApiPagingRequestDTO>): ApiPagingRequestModel;
  static toModel(dto: DeepPartial<ApiPagingRequestDTO> | undefined | null): ApiPagingRequestModel | undefined;
  static toModel(dto: DeepPartial<ApiPagingRequestDTO> | undefined | null): ApiPagingRequestModel | undefined {
    return dto ? new ApiPagingRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ApiPagingRequestModel> | ApiPagingRequestModel): ApiPagingRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      currentPage: unwrapped.currentPage,
      pageSize: unwrapped.pageSize,
      includeCount: unwrapped.includeCount,
      noPaging: unwrapped.noPaging,
    } as ApiPagingRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ApiPagingRequestModel, can not map to ApiPagingRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
